import { render, staticRenderFns } from "./AdminExpenses.vue?vue&type=template&id=6ac79cfc&"
import script from "./AdminExpenses.vue?vue&type=script&lang=js&"
export * from "./AdminExpenses.vue?vue&type=script&lang=js&"
import style0 from "./AdminExpenses.vue?vue&type=style&index=0&id=6ac79cfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports